// French formatting & dictionaries

export const DAYS_FR = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"];
export const DAYS_FR_SHORT = ["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"];
export const MONTHS_FR = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"];

export function formatDateFr(dateLike) {
  const d = typeof dateLike === "string" ? new Date(dateLike) : dateLike;
  if (!d || isNaN(d.getTime())) return "—";
  return `${DAYS_FR[d.getDay()]} ${d.getDate()} ${MONTHS_FR[d.getMonth()]} ${d.getFullYear()}`;
}

export function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth()+1).padStart(2,"0");
  const day = String(d.getDate()).padStart(2,"0");
  return `${y}-${m}-${day}`;
}

export function add30(time) {
  const [h,m] = time.split(":").map(Number);
  const total = h*60+m+30;
  return `${String(Math.floor(total/60)%24).padStart(2,"0")}:${String(total%60).padStart(2,"0")}`;
}

export function timeAgoFr(iso) {
  const t = new Date(iso).getTime();
  if (!t) return "";
  const diff = Date.now() - t;
  const min = Math.round(diff/60000);
  if (min < 1) return "À l'instant";
  if (min < 60) return `Il y a ${min} min`;
  const h = Math.round(min/60);
  if (h < 24) return `Il y a ${h} h`;
  const d = Math.round(h/24);
  if (d < 7) return `Il y a ${d} j`;
  return formatDateFr(iso);
}

export const ROLE_LABEL = {
  im: "Médecine Interne",
  obgyn: "OB-GYN",
  admin: "Administrateur",
};

export const URGENCY_LABEL = {
  routine: "Routine",
  urgent: "Urgent",
  very_urgent: "Très urgent",
};

export const STATUS_LABEL = {
  pending: "En attente",
  scheduled: "Planifié",
  seen: "Vue",
  missed: "Manqué",
  completed: "Terminé",
  need_info: "Info requise",
};

export const AGE_RANGES = [
  { v: "15-20", l: "15–20 ans" },
  { v: "20-30", l: "20–30 ans" },
  { v: "30-40", l: "30–40 ans" },
  { v: "40-45", l: "40–45 ans" },
];

export const DIAGNOSES = [
  { v: "cardiomyopathy", l: "Cardiomyopathie", d: "Atteinte myocardique chronique" },
  { v: "peripartum_cardiomyopathy", l: "Cardiomyopathie péripartum", d: "Début en fin de grossesse / post-partum" },
];

export const EF_RANGES = [
  { v: "20-30", l: "FEVG 20–30 %", d: "Dysfonction sévère" },
  { v: "30-40", l: "FEVG 30–40 %", d: "Dysfonction modérée à sévère" },
  { v: "40-50", l: "FEVG 40–50 %", d: "Dysfonction modérée" },
  { v: "50+", l: "FEVG ≥ 50 %", d: "Fonction préservée" },
];

export const PREGNANCY = [
  { v: "not_pregnant", l: "Non enceinte" },
  { v: "pregnant_t1", l: "Grossesse T1" },
  { v: "pregnant_t2", l: "Grossesse T2" },
  { v: "pregnant_t3", l: "Grossesse T3" },
  { v: "postpartum", l: "Post-partum" },
];

export const CONTRACEPTION = [
  { v: "none", l: "Aucune" },
  { v: "condom", l: "Préservatif" },
  { v: "copper_iud", l: "DIU cuivre" },
  { v: "hormonal_iud", l: "DIU hormonal" },
  { v: "implant", l: "Implant" },
  { v: "progestin_pill", l: "Pilule progestative" },
  { v: "combined_pill", l: "Pilule combinée" },
  { v: "dmpa", l: "DMPA (injection)" },
  { v: "sterilization", l: "Stérilisation" },
];

export const PLANS = [
  { v: "none_yet", l: "À déterminer" },
  { v: "progestin_pill", l: "Pilule progestative" },
  { v: "implant", l: "Implant" },
  { v: "hormonal_iud", l: "DIU hormonal" },
  { v: "copper_iud", l: "DIU cuivre" },
  { v: "dmpa", l: "DMPA (injection)" },
  { v: "permanent", l: "Méthode permanente" },
];

export const URGENCIES = [
  { v: "routine", l: "Routine", d: "Sous 2–4 semaines" },
  { v: "urgent", l: "Urgent", d: "Sous 7 jours" },
  { v: "very_urgent", l: "Très urgent", d: "Sous 48 h" },
];

export const LOCATIONS = ["Box Sono", "Box IVA", "Box Post-Natal", "Autres"];
// Providers list is now fetched dynamically from /api/obgyn/providers
